import {ChangeEvent, LegacyRef, FocusEvent, ReactNode} from "react"

export type PptInputProps = {
  labelText?: ReactNode
  name?: string
  id?: string
  type?: string
  onChange?: ((event: ChangeEvent<HTMLInputElement>) => void)
  value?: string
  placeholder?: string
  className?: string
  pattern?: string
  autoComplete?: string
  onBlur?: (event: FocusEvent<HTMLInputElement>) => unknown,
  inputRef?: LegacyRef<any> | null
  step?: string
}

export default function PptInput(
  props: PptInputProps
): JSX.Element {
  const {
    labelText = "Input",
    name = "",
    id,
    type = "text",
    onChange,
    value,
    placeholder = "",
    className = "",
    pattern,
    autoComplete = "",
    onBlur,
    inputRef = null,
    step
  } = props
  return (
    <label
      className={`ppt-input-container ${className}`}
      htmlFor={name}
      id={id}
    >
      <span className="ppt-input-label">
        {labelText}
      </span>
      <input
        className="ppt-input w100"
        placeholder={placeholder}
        name={name}
        value={onChange ? value : undefined}
        type={type}
        onChange={onChange}
        ref={inputRef ? inputRef : null}
        onBlur={onBlur}
        pattern={pattern}
        autoComplete={autoComplete}
        step={step}
      />
    </label>
  )
}